import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type SettingsPanelProps<T extends ElementType = 'div'> = {
  as?: T
  children: ReactNode
  className?: string
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children' | 'className'>

/** Bordered settings surface shared by form rows, tables, and lists. */
export function SettingsPanel<T extends ElementType = 'div'>({
  as,
  children,
  className,
  ...props
}: SettingsPanelProps<T>) {
  const Component = as ?? 'div'
  return (
    <Component
      className={cn('overflow-hidden rounded-md border bg-background', className)}
      {...props}
    >
      {children}
    </Component>
  )
}
